import moment from "moment";
import { buildNewOrderPayload } from "./newOrderPayload";

const date = (value) => value ? moment(value).format("YYYY-MM-DD") : null;
const hour = (value) => value != null ? moment(value).hour() : null;

export const buildExistingOrderPayload = (form, source, mode, userId) => {
  const original = { ...source.order, ...source.cargo };
  // Preserve editable-contract fields which do not have controls in the form.
  const retained = Object.fromEntries([
    "type", "isPublic", "length", "width", "height", "temperatureId", "referenceNumber",
  ].filter((key) => original[key] !== undefined).map((key) => [key, original[key]]));
  const originalAddresses = [...(source.order.addressList ?? [])].sort((a, b) => a.step - b.step);
  const endpoint = (from) => ({
    countryId: (from ? form.countryFrom : form.countryTo)?.id,
    cityId: (from ? form.cityFrom : form.cityTo)?.id,
    userAddressId: from ? form.addressIdFrom : form.addressIdTo,
    address: from ? form.addressFrom : form.addressTo,
    shippingDate: date(from ? form.pickUpDate : form.deliveryDate),
    shippingHourFrom: hour(from ? form.pickUpStartTime : form.deliveryStartTime),
    shippingHourTo: hour(from ? form.pickUpEndTime : form.deliveryEndTime),
    latLng: from ? form.coordinatesFrom : form.coordinatesTo,
    type: from ? 0 : 1,
    step: from ? 1 : form.points.length + 2,
    isInterimPoint: false,
    expectedUnloadingDate: mode === "copy" ? null
      : (from ? originalAddresses[0] : originalAddresses[originalAddresses.length - 1])?.expectedUnloadingDate ?? null,
    recipientName: from ? form.senderName : form.recipientName,
    recipientPhoneNumber: from ? form.senderPhone : form.recipientPhone,
    recipientEmail: from ? form.senderEmail : form.recipientEmail,
  });
  const addressList = [endpoint(true), ...form.points.map((point, index) => ({
    countryId: point.country?.id,
    cityId: point.city?.id,
    userAddressId: point.addressId,
    address: point.address,
    shippingDate: date(point.shippingDate),
    shippingHourFrom: hour(point.shippingHourFrom),
    shippingHourTo: hour(point.shippingHourTo),
    latLng: point.latLng,
    type: point.type,
    step: index + 2,
    isInterimPoint: true,
    expectedUnloadingDate: mode === "copy" ? null : point.expectedUnloadingDate ?? null,
    recipientName: point.recipientName,
    recipientPhoneNumber: point.recipientPhoneNumber,
    recipientEmail: point.recipientEmail,
  })), endpoint(false)];
  const data = {
    ...retained,
    ...(mode === "edit" ? {
      orderId: source.order.id,
      number: Number(source.order.number ?? 0),
      internalNumber: Number(source.order.internalNumber ?? 0),
    } : {}),
    userId: mode === "edit" ? source.order.userId : userId,
    price: form.price,
    copyCount: mode === "edit" ? 1 : form.copyCount,
    algoPrice: form.algoPrice,
    isAlgoPrice: source.order.isAlgoPrice ?? false,
    countryIdFrom: form.countryFrom?.id,
    cityIdFrom: form.cityFrom?.id,
    addressFrom: form.addressFrom,
    shippingDate: date(form.pickUpDate),
    shippingHourFrom: hour(form.pickUpStartTime),
    shippingHourTo: hour(form.pickUpEndTime),
    countryIdTo: form.countryTo?.id,
    cityIdTo: form.cityTo?.id,
    addressTo: form.addressTo,
    unloadingDate: date(form.deliveryDate),
    unloadingHourFrom: hour(form.deliveryStartTime),
    unloadingHourTo: hour(form.deliveryEndTime),
    latLng: form.coordinatesTo,
    recipientName: form.recipientName,
    recipientPhoneNumber: form.recipientPhone,
    recipientEmail: form.recipientEmail,
    addressList,
    isExistInterimPoint: form.points.length > 0,
    distance: form.routeDistance ?? 0,
    isActualCities: !(form.cityFrom?.isActual === false || form.cityTo?.isActual === false),
    details: form.details,
    weight: String(form.weight ?? "").replace(",", "."),
    volume: String(form.volume ?? "").replace(",", "."),
    pallet: String(form.pallet ?? "").replace(",", "."),
    category: form.category?.value,
    vehicleType: form.type?.value,
    temperature: form.temperature,
    loadingTypeId: form.loadingType?.id ?? null,
    unitMeasurement: form.weightUnit.code,
    tnvedCode: form.tnvedCode || null,
    insuranceIncluded: form.insurance,
    cargoPrice: form.declaredPrice,
    declaredPrice: form.insurance ? Number(form.declaredPrice) : null,
    insuranceSum: form.insurancePrice,
    insurancePrice: form.insurance ? form.insurancePrice : null,
    currency: form.acceptedCurrency,
    acceptedCurrency: form.acceptedCurrency,
    isWithoutExecutor: form.isWithoutExecutor,
    isAuctionExtended: form?.extendAuction ?? false,
    isImportedFromExcel: mode === "edit" ? source.order.isImportedFromExcel ?? false : false,
    bidReductionStep: form.auctionStep,
  };
  return buildNewOrderPayload(data, {
    ...form,
    assignmentMethod: mode === "edit" ? source.order.assignmentMethod : form.assignmentMethod,
  });
};
